// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YMaO","location":"Header_location__rkONs"};